module.exports = __webpack_public_path__ + "static/media/Diabetes-group-vanderbilt-saunders-brissova-haliyur.cf9c51fd.jpg";